import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-655b905e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "users-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"align-self":"flex-start"} }, "Users", -1))
const _hoisted_3 = {
  key: 0,
  class: "blink_me",
  style: {"margin-top":"200px"}
}

import { ref } from 'vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'UsersView',
  setup(__props) {

const loading = ref(true)

const load = () => {
    const iframe = document.getElementById('user-iframe');
    loading.value = false;
    iframe!.style.display = 'block';
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Loading..."))
      : _createCommentVNode("", true),
    _createElementVNode("iframe", {
      id: "user-iframe",
      width: "100%",
      height: "900px",
      onLoad: load,
      src: "https://lookerstudio.google.com/embed/reporting/248427a2-393b-4d31-8476-7f6306e5bffa/page/m2SYD",
      frameborder: "0",
      style: {"border":"0","display":"none"},
      allowfullscreen: ""
    }, null, 32)
  ]))
}
}

})